import { render, staticRenderFns } from "./AppDetailTab4.vue?vue&type=template&id=44667a48&scoped=true";
import script from "./AppDetailTab4.vue?vue&type=script&lang=js";
export * from "./AppDetailTab4.vue?vue&type=script&lang=js";
import style0 from "./AppDetailTab4.vue?vue&type=style&index=0&id=44667a48&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "44667a48", null);
export default component.exports;